import { AutocompleteInput, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { CalendarClock } from "lucide-react";
import {
  Create,
  DateInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "../common";

const statusChoices = [
  { id: "pending", name: "Pending" },
  { id: "approved", name: "Approved" },
  { id: "rejected", name: "Rejected" },
  { id: "cancelled", name: "Cancelled" },
];

const calculateDays = (data: any) => {
  if (!data.from_date || !data.to_date) return data;
  const from = new Date(data.from_date);
  const to = new Date(data.to_date);
  let days = 0;
  for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
    const day = d.getDay();
    if (day !== 0 && day !== 6) days += 1;
  }
  return { ...data, days: data.days || Math.max(days, 0) };
};

const LeaveRequestToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Submit Request" />
  </div>
);

export const LeaveRequestCreate = () => (
  <Create title="Create Leave Request" transform={calculateDays}>
    <Card className="form-container">
      <div className="form-header-premium">
        <CalendarClock className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Request Leave</h2>
      </div>
      <SimpleForm toolbar={<LeaveRequestToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ReferenceInput source="employee_id" reference="employees">
            <AutocompleteInput label="Employee" optionText="name" />
          </ReferenceInput>
          <ReferenceInput source="leave_type_id" reference="hr_leave_types">
            <AutocompleteInput label="Leave Type" optionText="name" />
          </ReferenceInput>
          <DateInput source="from_date" />
          <DateInput source="to_date" />
          <NumberInput
            source="days"
            helperText="Auto-filled from dates if left blank."
          />
          <SelectInput
            source="status"
            choices={statusChoices}
            defaultValue="pending"
          />
        </div>
        <TextInput source="reason" multiline fullWidth className="mt-4" />
      </SimpleForm>
    </Card>
  </Create>
);

